import * as React from 'react';
import * as style from './style.css';
import { Tooltip } from '@cian/ui-kit';
import { IconToggleHeartOff24, IconToggleHeartOn24 } from '@cian/ui-kit-design-tokens/icons';
import { OffersContext } from '../../../../shared/context';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const Favorite = _ref => {
  let {
    isFavorite,
    offerId
  } = _ref;
  const {
    addOfferToFavorites,
    removeOfferFromFavorites
  } = React.useContext(OffersContext);
  const toggleFavorite = React.useCallback(() => {
    if (isFavorite) {
      removeOfferFromFavorites(offerId);
    } else {
      addOfferToFavorites(offerId);
    }
  }, [isFavorite, offerId, addOfferToFavorites, removeOfferFromFavorites]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isFavorite ? 'В избранном' : 'Добавить в избранное',
    children: /*#__PURE__*/_jsx("button", {
      role: "button",
      "data-testid": "FavoriteButton",
      onClick: toggleFavorite,
      className: clsx(style['button'], isFavorite && style['active']),
      children: isFavorite ? /*#__PURE__*/_jsx(IconToggleHeartOn24, {
        color: "current_color"
      }) : /*#__PURE__*/_jsx(IconToggleHeartOff24, {
        color: "current_color"
      })
    })
  });
};